import { Autocomplete, Checkbox, TextField, textFieldVariants } from '@ghs/components';
import { FormControlLabel, Grid } from '@mui/material';
import { useUnit } from 'effector-react';
import { $$theme } from 'services/ThemeService/model';
import type { CampaignSetupOption, CreateFormData } from './types';

type Props = {
  formData: Partial<CreateFormData>;
  contactOptions: CampaignSetupOption[];
  onChange: (patch: Partial<CreateFormData>) => void;
};

export default function ContactDetailsSection({ formData, contactOptions, onChange }: Props) {
  const { palette } = useUnit($$theme.$palette);

  const requiredSup = (
    <sup style={{ color: palette.error.main, fontSize: '1em' }} aria-label="This is a required field">
      *
    </sup>
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Autocomplete
          id="client-contact"
          label={<span>{requiredSup} Client Contact</span>}
          placeholder="Select a contact..."
          options={contactOptions}
          variant={textFieldVariants.OUTLINED}
          sx={{ width: '100%' }}
          value={contactOptions.find(opt => opt.id === formData.contactId) || null}
          onChange={(_event, value) => onChange({ contactId: value?.id || null })}
          getOptionKey={opt => opt.id}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          label="Client PO#"
          placeholder="Enter client PO number"
          value={formData.clientPo ?? ''}
          onChange={e => onChange({ clientPo: e.target.value })}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          sx={{ ml: 0, '& .MuiFormControlLabel-label': { ml: -1.5 } }}
          control={<Checkbox checked={formData.sendNotification ?? false} onChange={e => onChange({ sendNotification: e.target.checked })} />}
          label="Send Processing Notification to Client Contact"
        />
      </Grid>
    </Grid>
  );
}
